<gene-avatar [size]="size" [bgColor]="'#E71316'">
  @if (icon === 'dialog') {
    <fa-icon [icon]="faCommentDotsIcon" style="font-size: 18px;" data-testid="dialog-icon"/>
  } @else {
    <img src="assets/icons/chat-assistant/chat-assistant-icon.svg" alt="Assistant icon" height="40" width="40" data-testid="assistant-icon">
  }
</gene-avatar>
